import { useEffect } from "react";
import PropTypes from "prop-types";

import "./celda-cuadro-turnos.css";
import useTurno from "../../../../../core/hooks/use-turno";
import { intercambiarCuadrosTurnos } from "../../../services/nomina-cuadro-turnos";
import { toast } from "../../../../../core/helpers/message-helper";
import useOpciones from "../../../../../core/hooks/use-opciones";

const CeldaCuadroTurno = ({
    fecha,
    turno = {},
    subAreaId,
    idCeldaTurno,
    getEstiloCelda,
    totalHorasSemanaId,
    totalHorasAcumuladasId,
}) => {
    const opcionesTurnos = useOpciones("turnos");
    const opcionesActividades = useOpciones("actividades");

    const {
        agregarTurno,
        obtenerTurnosSeleccionados,
        vaciarTurnosSeleccionados,
        estaTurnoSeleccionado,
        removerCeldasActivas,
        actualizarCeldasTurnos,
    } = useTurno();

    useEffect(() => {
        const celda = document.getElementById(idCeldaTurno);

        const onClickDerecho = function (evento) {
            const turno = celda.dataset;
            evento.preventDefault();
            opcionesTurnos.ocultarCuadroOpciones();
            opcionesActividades.resetOpciones();
            opcionesActividades.resetScrollOpciones();
            opcionesActividades.focusBuscadorOpciones();
            reiniciarSeleccionMultiple(turno);
            celda.classList.add("activo");

            opcionesActividades.mostrarCuadroOpciones(evento, obtenerTurnosSeleccionados());
        };

        celda.addEventListener("contextmenu", onClickDerecho);
        return () => celda.removeEventListener("contextmenu", onClickDerecho);
    }, []);

    const onClickCelda = (evento) => {
        opcionesActividades.ocultarCuadroOpciones();
        const celdaTurno = document.getElementById(idCeldaTurno);
        const turno = celdaTurno.dataset;

        if (evento.ctrlKey) {
            celdaTurno.classList.add("activo");
            agregarTurno(turno);
        } else {
            opcionesTurnos.resetOpciones();
            opcionesTurnos.resetScrollOpciones();
            opcionesTurnos.mostrarCuadroOpciones(
                evento,
                idCeldaTurno,
                turno.idcuadroturno
            );
            opcionesTurnos.focusBuscadorOpciones();
            reiniciarSeleccionMultiple(turno);
            celdaTurno.classList.add("activo");
        }
    };

    const reiniciarSeleccionMultiple = (turnoPulsado) => {
        const turnosSeleccionados = obtenerTurnosSeleccionados();

        if (
            turnosSeleccionados.length == 0 ||
            turnosSeleccionados.length == 1 ||
            !estaTurnoSeleccionado(turnoPulsado.idcuadroturno)
        ) {
            removerCeldasActivas();
            vaciarTurnosSeleccionados();
            agregarTurno(turnoPulsado);
        }
    };

    const onDragOverCelda = (e) => {
        const celdaTurno = document.getElementById(idCeldaTurno);
        const turno = celdaTurno.dataset;
        e.dataTransfer.setData("turno", JSON.stringify(turno));
    };

    const onDropCelda = async (event) => {
        event.preventDefault();
        const celdaTurno = document.getElementById(idCeldaTurno);
        const turnoActual = Object.assign({}, celdaTurno.dataset);
        const data = event.dataTransfer.getData("turno");

        if (data) {
            const nuevoTurno = Object.assign({}, JSON.parse(data));

            if (event.ctrlKey) {
                const idsCuadrosTurnos = [
                    parseInt(turnoActual.idcuadroturno),
                    parseInt(nuevoTurno.idcuadroturno),
                ];

                if (nuevoTurno.turnosede == turnoActual.turnosede) return;

                actualizarCeldasTurnos(
                    {
                        ...nuevoTurno,
                        horas_turno: nuevoTurno.horas,
                        turno_sede: nuevoTurno.turnosede,
                    },
                    { ...turnoActual }
                );

                actualizarCeldasTurnos(
                    {
                        ...turnoActual,
                        horas_turno: turnoActual.horas,
                        turno_sede: turnoActual.turnosede,
                    },
                    { ...nuevoTurno }
                );

                const resp = await intercambiarCuadrosTurnos(idsCuadrosTurnos);
                if (!resp.status) return toast.error(resp.message);
            }
        }
    };

    function allowDrop(event) {
        event.preventDefault();
    }

    let actividades = turno.actividades ?? [];
    const spanId = `${idCeldaTurno}-${turno.sigla}`;

    return (
        <td
            draggable={true}
            id={idCeldaTurno}
            onClick={onClickCelda}
            key={`${idCeldaTurno}-td`}
            className="celda-cuadro-turno"
            data-fecha={fecha}
            data-subarea={subAreaId}
            data-horas={turno.horas}
            data-libre={turno.libre}
            data-sigla={turno.sigla}
            data-color={turno.color}
            data-idceldaturno={idCeldaTurno}
            data-idcuadroturno={turno.id_cuadro_turno}
            data-turnosede={turno.fk_nomina_turno_sede}
            data-totalhorassemanaid={totalHorasSemanaId}
            data-totalhorasacumuladasid={totalHorasAcumuladasId}
            style={getEstiloCelda(fecha, turno.color ?? "white")}
            onDragStart={onDragOverCelda}
            onDrop={onDropCelda}
            onDragOver={allowDrop}
        >
            {actividades && actividades.length > 0 && (
                <>
                    <span className="iconos-actividades">
                        {actividades.map((actividad) => {
                            return (
                                <i
                                    id={`actividad-${actividad.id}-${actividad.nomina_cuadros_turnos_id}`}
                                    key={`${actividad.id}-${actividad.nomina_cuadros_turnos_id}`}
                                    className={`${actividad.icono} actividad-${actividad.id} actividad`}
                                    style={{
                                        color: actividad.color,
                                        marginRight: "3px",
                                    }}
                                    title={actividad.nombre}
                                    data-id={actividad.id}
                                ></i>
                            );
                        })}
                    </span>
                    <br />
                </>
            )}
            <span
                key={spanId}
                className="sigla-turno"
                id={spanId}
                style={{ fontSize: "10px" }}
            >
                {turno.sigla ?? ""} <br />
            </span>
        </td>
    );
};

CeldaCuadroTurno.propTypes = {
    turno: PropTypes.object,
    fecha: PropTypes.string,
    subAreaId: PropTypes.number,
    personaId: PropTypes.number,
    opcionesTurnos: PropTypes.array,
    idCeldaTurno: PropTypes.string,
    getEstiloCelda: PropTypes.func,
    sedeAreaLider: PropTypes.number,
    modalEditarTurnos: PropTypes.object,
    totalHorasSemanaId: PropTypes.string,
    totalHorasAcumuladasId: PropTypes.string,
};

export default CeldaCuadroTurno;
